<template>
    <div class="columns is-centered">
        <div class="column is-12-tablet is-6-desktop">
            <form
                v-if="$meta.features.tenants.online_payments"
                class="box"
                @submit.prevent="submit"
            >
                <h4 class="title is-4">
                    Pay Online
                </h4>

                <p>
                    Pay online securely, with no fees.
                    It may take a few days for your transaction to be processed.
                </p>

                <Notification v-if="! $meta.isSagepayInProduction">
                    Testing mode
                </Notification>

                <PaymentNotification />

                <FormNotification />

                <SavingNotification>
                    Sending...
                </SavingNotification>

                <b-field label="Payment Description/Reference">
                    <b-input
                        v-model="Reason"
                        v-validate="{ required: true }"
                        name="Reason"
                    />
                </b-field>

                <b-field label="Amount (£)">
                    <b-input
                        v-model="Amount"
                        v-validate="{ required: true }"
                        name="Amount"
                    />
                </b-field>

                <hr />

                <div class="columns">
                    <div class="column">
                        <b-field label="First name(s)">
                            <b-input
                                v-model="FirstName"
                                v-validate="{ required: true }"
                                name="FirstName"
                            />
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Surname">
                            <b-input
                                v-model="Surname"
                                v-validate="{ required: true }"
                                name="Surname"
                            />
                        </b-field>
                    </div>
                </div>

                <b-field label="Address Line 1">
                    <b-input
                        v-model="AddressLine1"
                        v-validate="{ required: true }"
                        name="AddressLine1"
                    />
                </b-field>

                <b-field label="Address Line 2">
                    <b-input
                        v-model="AddressLine2"
                        name="AddressLine2"
                    />
                </b-field>

                <div class="columns">
                    <div class="column">
                        <b-field label="Town/City">
                            <b-input
                                v-model="Town"
                                v-validate="{ required: true }"
                                name="Town"
                            />
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Postcode">
                            <b-input
                                v-model="Postcode"
                                v-validate="{ required: true }"
                                name="Postcode"
                            />
                        </b-field>
                    </div>
                </div>

                <hr />

                <b-button
                    type="is-info"
                    icon-left="lock"
                    native-type="submit"
                    :disabled="isSendingOrSuccess"
                >
                    Pay
                </b-button>
            </form>

            <div v-else-if="$meta.features.tenants.bank_account">
                <h5>
                    Pay by bank transfer:
                </h5>

                <BankDetails />

                <p class="mt-2">
                    Please use a recognisable reference,
                    such as your surname and/or property road name.
                </p>
            </div>

            <form
                ref="payment-form-2"
                method="POST"
                :action="gatewayResponse.Endpoint"
            >
                <input
                    type="hidden"
                    name="VPSProtocol"
                    :value="gatewayResponse.VPSProtocol"
                >
                <input
                    type="hidden"
                    name="TxType"
                    :value="gatewayResponse.TxType"
                >
                <input
                    type="hidden"
                    name="Vendor"
                    :value="gatewayResponse.Vendor"
                >
                <input
                    type="hidden"
                    name="Crypt"
                    :value="gatewayResponse.CryptToken"
                >
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Form from '../mixins/form.js';
import PaymentNotification from '../components/PaymentNotification';
import BankDetails from '../components/BankDetails';
import Vue from 'vue';

export default {
    components: {
        PaymentNotification,
        BankDetails,
    },

    mixins: [
        Form,
    ],

    data() {
        return {
            gatewayResponse: {
                CryptToken: '',
                Endpoint: '',
                TxType: '',
                VPSProtocol: '',
                Vendor: '',
            },
        };
    },

    computed: {
        ...mapState('tenancyProperty', {
            tenancyProperty: 'property',
        }),
        ...mapFields('pay', [
            'payment.Reason',
            'payment.Amount',
            'payment.FirstName',
            'payment.Surname',
            'payment.AddressLine1',
            'payment.AddressLine2',
            'payment.Town',
            'payment.Postcode',
        ]),
    },

    mounted() {
        // set amount if supplied as GET variable
        if(this.$route.query.amount && ! isNaN(this.$route.query.amount)) {
            this.Amount = this.$route.query.amount;
        }
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return;
                }

                this.$store.dispatch('pay/submit', {
                    rowPK: this.tenancyProperty.TenancyFK,
                    path: this.$route.path,
                })
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;

                    // update response fields
                    this.gatewayResponse = response.data.data;

                    // wait until DOM has been updated before submitting form
                    Vue.nextTick(() => {
                        this.$refs['payment-form-2'].submit();
                    });
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
